import { render, staticRenderFns } from "./MonitoringCriterionComplaint.vue?vue&type=template&id=099884f4"
import script from "./MonitoringCriterionComplaint.vue?vue&type=script&lang=js"
export * from "./MonitoringCriterionComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports